import React, { useState } from "react";
import "../css/AccountsRegisterPage.css";
import { createUserWithEmailAndPassword, signOut, signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase-config";
import { setDoc, doc } from "firebase/firestore";
import { serverTimestamp } from "firebase/firestore";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AccountsRegisterPage = () => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [userType, setUsertype] = useState("")
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const [isLoading, setIsLoading] = useState(false);
    

    const validateForm = () => {
        const newErrors = {};
        
        if (!email || !emailRegex.test(email)) {
            newErrors.email = !email ? 'Email is required' : 'Invalid email format';
        }

        if (!password || password.length <= 6) {
            newErrors.password = password ? 'Password must be at least 7 characters.' : 'Password is required';
        }

        if (!confirmPassword || confirmPassword !== password) {
            newErrors.confirmPassword = 'Passwords do not match.';
        }

        if (!userType || userType === "") {
            newErrors.userType = 'User Type is required';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleRegister = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
          // Prompt admin to enter their password
          const currentUser = auth.currentUser;
          
          // Use SweetAlert2 to create a password input dialog
          const { value: adminPassword } = await Swal.fire({
            title: `Enter your password (${currentUser.email})`,
            input: 'password',
            inputLabel: 'Password',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel'
        });
  
        if (!adminPassword) {
            toast.error("Admin authentication failed", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              });
            throw new Error("Admin authentication failed");
        }

        // Verify the admin's credentials
        let verifyResult;
        try {
            setIsLoading(true); // Set loading state to true
            await signInWithEmailAndPassword(auth, currentUser.email, adminPassword);
            verifyResult = true;
        } catch (error) {
            if (error.code === 'auth/invalid-credential') {
                throw error; // Re-throw the error to handle it later
            }
            verifyResult = false;
        }

        if (!verifyResult) {
            throw new Error("Admin authentication failed");
        }

          // Create the new user
          const userCredential = await createUserWithEmailAndPassword(auth, email, password);
          const newUser = userCredential.user;

          toast.info("New user successfully created! You will now be redirected to Manage Users.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
        });
      
          // Sign out the newly created user
          await signOut(auth);
      
          // Log back in the original user
          await signInWithEmailAndPassword(auth, currentUser.email, adminPassword);
      
          // Store user data in Firestore
          await setDoc(doc(db, "users", newUser.uid), {
            email: newUser.email,
            usertype: userType,
            dateCreated: serverTimestamp()
          });
      
          console.log("User Registered Successfully!");

          // Redirect to AccountManageUsers after successful registration
          navigate('/pages/AccountsManageUsers');

        } catch (error) {
          console.error("Error registering user:", error.message);
          if (error.code === 'auth/email-already-in-use') {
            toast.error("Email already in use. Please try another email address.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
        } else if (error.code === 'auth/invalid-credential') {
            toast.error("Invalid password. Please try again.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              });
          }
        } finally {
            setIsLoading(false); // Reset loading state
          }
      };
      

    return (
        
        <div className="register-page">
            <div className="register-content">
                
                <form className="register-form" onSubmit={handleRegister}>
                <h1>Register Account</h1>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="text"
                            id="email"
                            name="email"
                            placeholder="Email"
                            onChange={(e) => setEmail(e.target.value)}
                            className={`form-control ${errors.email ? 'error-border' : ''}`}
                        />
                         {errors.email && <div className="error-message">{errors.email}</div>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Password"
                            onChange={(e) => setPassword(e.target.value)}
                            className={`form-control ${errors.password ? 'error-border' : ''}`}
                        />
                        {errors.password && <div className="error-message">{errors.password}</div>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className={`form-control ${errors.confirmPassword ? 'error-border' : ''}`}
                        />
                        {errors.confirmPassword && <div className="error-message">{errors.confirmPassword}</div>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="usertype">User Type</label>
                        <select
                            id="usertype"
                            name="usertype"
                            onChange={(e) => setUsertype(e.target.value)}
                            className={`form-control ${errors.userType ? 'error-border' : ''}`}
                        >
                            <option value="">Select User Type</option>
                            <option value="Employee">Employee</option>
                            <option value="Manager">Manager</option>
                            <option value="Admin">Admin</option>
                        </select>
                        {errors.userType && <div className="error-message">{errors.userType}</div>}
                    </div>
                    <button type="submit" className="save-entries-btn" disabled={isLoading}>
                        {isLoading ? 'Registering...' : 'Register'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AccountsRegisterPage;